/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType.js";
import { useEffect, useState } from "react";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import "react-reflex/styles.css";
import { useSetRecoilState } from "recoil";
import getSchema from "../../lib/api/getSchema.js";
import notificationState from "../../states/notificationState.js";

import layoutConf from "../../config/layoutConf.js";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout.js";
import BarcodePrintButton from "../input/BarcodePrintButton.js";
import CreateRecordButton from "../input/CreateRecordButton.js";
import TestBarcodeScanButton from "../input/TestBarcodScanButton.js";

function TestBarcodePrintScanComponent(props) {
    const [height, setHeight] = useState(0);

    const [lotGrid, setLotGrid] = useState();
    const [machineGrid, setMachineGrid] = useState();
    const [workerGrid, setWorkerGrid] = useState();

    const [lotSelected, setLotSelected] = useState();
    const [machineSelected, setMachineSelected] = useState();
    const [workerSelected, setWorkerSelected] = useState();

    const [lotSchema, setLotSchema] = useState();
    const [machineSchema, setMachineSchema] = useState();
    const [workerSchema, setWorkerSchema] = useState();

    const [lotApi, setLotApi] = useState();
    const [machineApi, setMachineApi] = useState();
    const [workerApi, setWorkerApi] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize();

        let mounted = true;

        (async () => {
            const description = {
                name: "description",
                formItemType: "text",
                width: "93%",
                multiline: true,
                rows: 4,
            };

            const lotSchema = await getSchema("MomSysSgtLot");
            const machineSchema = await getSchema("MomSysMstMachine");
            const workerSchema = await getSchema("User");

            if (mounted) {
                lotSchema.columns = [];
                lotSchema.columns.push(
                    {
                        name: "barcode",
                        barcodeScanTarget: "lot",
                        formItemType: "barcodeScan",
                    },
                    description
                );
                setLotSchema(lotSchema);

                machineSchema.columns = [];
                machineSchema.formGroups = ["essential"];
                machineSchema.columns.push(
                    {
                        name: "barcode",
                        barcodeScanTarget: "machine",
                        formItemType: "barcodeScan",
                    },
                    description
                );
                setMachineSchema(machineSchema);

                workerSchema.columns = [];
                workerSchema.formGroups = ["essential"];
                workerSchema.columns.push(
                    {
                        name: "barcode",
                        barcodeScanTarget: "worker",
                        formItemType: "barcodeScan",
                    },
                    description
                );
                setWorkerSchema(workerSchema);
            }
        })();

        return () => {
            mounted = false;
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (lotGrid) {
            const handleGridSelection = (grid) => {
                setLotSelected(grid.selectedItems?.length ? grid.selectedItems[0] : []);
            };

            lotGrid.selectionChanged.addHandler(handleGridSelection);
            lotGrid.itemsSourceChanged.addHandler(handleGridSelection);

            return () => {
                if (lotGrid && !lotGrid.isDestroyed) {
                    lotGrid.selectionChanged.removeHandler(handleGridSelection);
                    lotGrid.itemsSourceChanged.removeHandler(handleGridSelection);
                }
            };
        }
    }, [lotGrid]);

    useEffect(() => {
        if (machineGrid) {
            const handleGridSelection = (grid) => {
                setMachineSelected(grid.selectedItems?.length ? grid.selectedItems[0] : []);
            };

            machineGrid.selectionChanged.addHandler(handleGridSelection);
            machineGrid.itemsSourceChanged.addHandler(handleGridSelection);

            return () => {
                if (machineGrid && !machineGrid.isDestroyed) {
                    machineGrid.selectionChanged.removeHandler(handleGridSelection);
                    machineGrid.itemsSourceChanged.removeHandler(handleGridSelection);
                }
            };
        }
    }, [machineGrid]);

    useEffect(() => {
        if (workerGrid) {
            const handleGridSelection = (grid) => {
                setWorkerSelected(grid.selectedItems?.length ? grid.selectedItems[0] : []);
            };

            workerGrid.selectionChanged.addHandler(handleGridSelection);
            workerGrid.itemsSourceChanged.addHandler(handleGridSelection);

            return () => {
                if (workerGrid && !workerGrid.isDestroyed) {
                    workerGrid.selectionChanged.removeHandler(handleGridSelection);
                    workerGrid.itemsSourceChanged.removeHandler(handleGridSelection);
                }
            };
        }
    }, [workerGrid]);

    const onInitialized = (grid, type) => {
        grid.selectionMode = "Row";

        switch (type) {
            case "lot":
                setLotGrid(grid);
                break;
            case "machine":
                setMachineGrid(grid);
                break;
            case "worker":
                setWorkerGrid(grid);
                break;
            default:
                break;
        }
    };

    const onLotApiInitialized = (api) => {
        setLotApi(api);
    };

    const onMachineApiInitialized = (api) => {
        setMachineApi(api);
    };

    const onWorkerApiInitialized = (api) => {
        setWorkerApi(api);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const barcodeCallback = (barcodeData) => {
    };

    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="horizontal">
                <ReflexElement flex={0.35}>
                    <BasicCrudScreenType
                        id="lot"
                        table="MomSysSgtLot"
                        view="MomSysZvwSgtLot"
                        onInitialized={(grid) => onInitialized(grid, "lot")}
                        onApiInitialized={(api) => onLotApiInitialized(api)}
                        noCreate
                        noExcel
                        noEdit
                        noDelete
                        noFilter
                        onAppendButtonInFrontOfSearch={() => (
                            <>
                                <BasicCrudScreenActionItemLayout>
                                    <BarcodePrintButton
                                        barcodeIssueTarget="lot"
                                        barcodeInfos={[lotSelected]}
                                        barcodeUsage="lot"
                                        onFailure={onFailure}
                                    />
                                </BasicCrudScreenActionItemLayout>
                                <BasicCrudScreenActionItemLayout>
                                    <TestBarcodeScanButton
                                        schema={lotSchema}
                                        refresh={lotApi}
                                        buttonName="buttonName.barcodeScan"
                                        onSuccess={onSuccess}
                                        barcodeCallback={barcodeCallback}
                                    />
                                </BasicCrudScreenActionItemLayout>
                            </>
                        )}
                    />
                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement flex={0.35}>
                    <BasicCrudScreenType
                        id="machine"
                        table="MomSysMstMachine"
                        view="MomSysZvwMachine"
                        onInitialized={(grid) => onInitialized(grid, "machine")}
                        onApiInitialized={(api) => onMachineApiInitialized(api)}
                        noCreate
                        noExcel
                        noEdit
                        noDelete
                        onAppendButtonInFrontOfSearch={() => (
                            <>
                                <BasicCrudScreenActionItemLayout>
                                    <BarcodePrintButton
                                        barcodeIssueTarget="machine"
                                        barcodeInfos={[machineSelected]}
                                        barcodeUsage="machine"
                                        onFailure={onFailure}
                                    />
                                </BasicCrudScreenActionItemLayout>
                                <BasicCrudScreenActionItemLayout>
                                    <TestBarcodeScanButton
                                        schema={machineSchema}
                                        refresh={machineApi}
                                        buttonName="buttonName.barcodeScan"
                                        onSuccess={onSuccess}
                                        barcodeCallback={barcodeCallback}
                                    />
                                </BasicCrudScreenActionItemLayout>
                            </>
                        )}
                    />
                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement flex={0.3}>
                    <BasicCrudScreenType
                        id="worker"
                        table="User"
                        view="VwUser"
                        onInitialized={(grid) => onInitialized(grid, "worker")}
                        onApiInitialized={(api) => onWorkerApiInitialized(api)}
                        noCreate
                        noExcel
                        noEdit
                        noDelete
                        onAppendButtonInFrontOfSearch={() => (
                            <>
                                <BasicCrudScreenActionItemLayout>
                                    <BarcodePrintButton
                                        barcodeIssueTarget="worker"
                                        barcodeInfos={[workerSelected]}
                                        barcodeUsage="worker"
                                        onFailure={onFailure}
                                    />
                                </BasicCrudScreenActionItemLayout>
                                <BasicCrudScreenActionItemLayout>
                                    <TestBarcodeScanButton
                                        schema={workerSchema}
                                        refresh={workerApi}
                                        buttonName="buttonName.barcodeScan"
                                        onSuccess={onSuccess}
                                        barcodeCallback={barcodeCallback}
                                    />
                                </BasicCrudScreenActionItemLayout>
                            </>
                        )}
                    />
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default TestBarcodePrintScanComponent;
